<template>
  <section
    class="bg-gray-10 relative z-10 before:absolute before:w-screen before:h-full before:top-0 before:right-0 before:pointer-events-none before:bg-gray-10 max-lg:w-full"
  >
    <div class="pr-10 py-10 relative max-lg:w-full max-lg:px-5">
      <!-- header -->
      <div class="font-bold text-xl md:max-w-[265px] truncate">
        {{ $t('myAccount.welcomeBack') }}
        <span class="text-primary-tangerine">{{ user?.first_name }}</span>
      </div>

      <!-- menu -->
      <div class="mt-4 gap-y-2 flex flex-col">
        <NuxtLinkLocale
          v-for="(item, index) in menuList"
          :key="index"
          :to="item.url"
          class="bg-white p-4 rounded-2xl justify-between w-[265px] flex items-center hover:opacity-50 max-lg:w-full"
        >
          <div class="flex items-center space-x-2">
            <div class="w-8 h-8 flex items-center justify-center">
              <Icon :name="item.icon" />
            </div>
            <div class="font-bold">{{ item.name }}</div>
          </div>
          <Icon name="chevron-right" />
        </NuxtLinkLocale>
        <div
          class="bg-white p-4 rounded-2xl justify-between w-[265px] flex items-center cursor-pointer hover:opacity-50 max-lg:w-full"
          @click="handleLogout"
        >
          <div class="flex items-center space-x-2">
            <div class="w-8 h-8 flex items-center justify-center">
              <Icon name="right-from-bracket" />
            </div>
            <div class="font-bold">{{ $t('myAccount.logOut') }}</div>
          </div>
          <Icon name="chevron-right" />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const { logout } = useUserStore()
const router = useRouter()
const localePath = useLocalePath()
const { t } = useI18n()
const userStore = useUserStore()
const { user } = storeToRefs(userStore)

const menuList = [
  {
    name: t('myAccount.myOrders'),
    url: '/account/my-orders',
    icon: 'truck-clock'
  },
  // {
  //   name: t('myAccount.myGallery'),
  //   url: '/account/my-gallery',
  //   icon: 'gallery'
  // },
  {
    name: t('myAccount.wishlist'),
    url: '/account/wishlist',
    icon: 'heart-outline'
  },
  {
    name: t('myAccount.myAccount'),
    url: '/account/my-account',
    icon: 'user-circle'
  },
  {
    name: t('myAccount.myAddress'),
    url: '/account/my-address',
    icon: 'home'
  }
]

const handleLogout = () => {
  logout()
  router.push(localePath('/'))
}
</script>
